<template>
        <div>
	        <form @submit="formSubmit" enctype="multipart/form-data">
            <input class="input" type="hidden" v-model="fdata.id" >
			<input class="input" type="hidden" v-model="employee_id" >
			<input class="input" type="hidden" v-model="fiscal_year" >
			<input class="input" type="hidden" v-model="from_date" >
			<input class="input" type="hidden" v-model="to_date" >
			<input class="input" type="hidden" v-model="pay_slip_ref" >
			<input class="input" type="hidden" v-model="pay_slip_name" >
			
			                <div class="row">
							<div class="col-md-6" style="min-width:200px"><h2>{{fdata.employee_name}}</h2></div>
							</div>
							
							<div class="row">
							<div class="col-md-6"><img :src="$api_url+'/images/employee/'+fdata.pic+''" width="100"></div>
							</div>
							
							<div class="row" style="padding-top:10px">
							<div class="col-md-6">Employee ID: {{fdata.employee_id}} &nbsp;&nbsp;&nbsp; Gender: {{fdata.gender}}&nbsp;&nbsp;&nbsp; Income Year: {{fiscal_year}}</div>
							
							</div>
							
							<div class="row" style="padding-top:10px">
							<div class="col-md-6">
							<b>{{pay_slip_name}}</b>
							</div>
							</div>
							
							<hr>
							
							
							<div class="row">
							<div class="col-md-6"><h3>Details of Taxable Income</h3></div>
							</div>
							
							<div class="row">
							  <div class="col-md-12">
							    <table class="table table-bordered table-striped table-hover">
							       <tbody>
							            <tr><td><b>Heads of Income</b></td> <td><b>Monthly Amount</b></td> <td><b>Allowable Excemption</b></td> <td><b>Taxable Income</b></td> <td><b>Annual Taxable Income</b></td></tr>

							            <tr v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.displayset == '1'">
							              <td>{{salaryhead.head}}</td> <td>{{salaryhead.value}}</td> <td>{{salaryhead.exemption}}</td> <td>{{salaryhead.taxable}}</td> <td>{{salaryhead.annual}}</td>
							            </tr>
										
										
										<tr v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.displayset == 'adhoc'">
							              <td>{{salaryhead.head}}</td> <td>{{salaryhead.value}}</td> <td>{{salaryhead.exemption}}</td> <td>{{salaryhead.taxable}}</td> <td>{{salaryhead.annual}} <a href="javascript:voide(0);" style="float:right; text-align:right"  @click="removeItem(salaryhead.id)">Remove</a></td>
							            </tr>
							
							            <tr v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.displayset == '100'">
							            <td><b>{{salaryhead.head}}</b></td> <td><b>{{salaryhead.value}}</b></td> <td><b>{{salaryhead.exemption}}</b></td> <td><b>{{salaryhead.taxable}}</b></td> <td><b>{{salaryhead.annual}}</b></td>
							            </tr>
							       </tbody>
							      </table>
							   </div>
						 </div>
					
					
					
					 <div class="row" id="adhoc_link_div">
					 
					 
					 <div class="col-md-4">	 
					 <div style="display:none" id="status_div"></div>
                     </div>
					 </div> 
					 
					 <div style="display:none" id="adhoc_div">
				     
					 </div>
							


                            <hr>

							<div class="row">
							<div class="col-md-6"><h3>Income Tax Liability</h3></div>
							</div>
							
							<div class="row">
							  <div class="col-md-12">
							    <table class="table table-bordered table-striped table-hover">
							       <tbody>
							            <tr><td><b>Details</b></td> <td><b>Slab</b></td> <td><b>Tax Rate</b></td> <td><b>Tax Amount</b></td></tr>

							            <tr v-for="slabsnvalue in slabs_and_values" v-if="slabsnvalue.displayset == '3'">
							              <td>{{slabsnvalue.head}}</td> <td>{{slabsnvalue.slab}}</td> <td>{{slabsnvalue.tax_rate}}</td> <td>{{slabsnvalue.tax_amount}}</td>
							            </tr>
										
										<tr v-for="slabsnvalue in slabs_and_values" v-if="slabsnvalue.displayset == '300'">
							              <td><b>{{slabsnvalue.head}}</b></td> <td><b>{{slabsnvalue.slab}}</b></td> <td><b>{{slabsnvalue.tax_rate}}</b></td> <td><b>{{slabsnvalue.tax_amount}}</b></td>
							            </tr>
							
							            
							       </tbody>
							      </table>
							   </div>
						 </div>
                            <hr>

							<div class="row">
							<div class="col-md-6"><h3>Income Tax Payable</h3></div>
							</div>
							
							<div class="row">
							  <div class="col-md-12">
							    <table class="table table-bordered table-striped table-hover">
							       <tbody>
							            <tr><td><b>Details</b></td> <td><b>Amount</b></td></tr>

							            <tr v-for="taxhead in taxinfo" :key="taxhead.head">
							              <td>{{taxhead.head}}</td> <td>{{taxhead.value}}</td>
							            </tr>
										
										
							
							            
							       </tbody>
							      </table>
							   </div>
						 </div>
                           <hr>

							<div class="row">
							<div class="col-md-6"><h3>Other Non-Taxable Income</h3></div>
							</div>
							
							<div class="row">
							  <div class="col-md-12">
							    <table class="table table-bordered table-striped table-hover">
							       <tbody>
							            <tr><td><b>Heads of Income</b></td> <td><b>Monthly Amount</b></td></tr>

							            <tr v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.displayset == '2'">
							              <td>{{salaryhead.head}}</td> <td>{{salaryhead.value}}</td> 
							            </tr>
										
							       </tbody>
							      </table>
							   </div>
						 </div>



                           <hr>

							<div class="row">
							<div class="col-md-6"><h3>Deductions</h3></div>
							</div>
							
							<div class="row">
							  <div class="col-md-12">
							    <table class="table table-bordered table-striped table-hover">
							       <tbody>
							            <tr><td><b>Heads of Deduction</b></td> <td><b>Monthly Amount</b></td></tr>

							            <tr v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.displayset == '5'">
							              <td>{{salaryhead.head}}</td> <td>{{salaryhead.value}}</td> 
							            </tr>
										
										<tr v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.displayset == '500'">
							              <td><b>{{salaryhead.head}}</b></td> <td><b>{{salaryhead.value}}</b></td> 
							            </tr>
										
							       </tbody>
							      </table>
							   </div>
						 </div>

                           <hr>

							<div class="row">
							<div class="col-md-6"><h3>Salary Payable</h3></div>
							</div>
							
							<div class="row">
							  <div class="col-md-12">
							    <table class="table table-bordered table-striped table-hover">
							       <tbody>
							            <tr><td><b>Details</b></td> <td><b>Amount</b></td></tr>

							            <tr v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.displayset == '6'">
							              <td>{{salaryhead.head}}</td> <td>{{salaryhead.value}}</td> 
							            </tr>
										
										<tr v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.displayset == '500'">
							              <td>{{salaryhead.head}}</td> <td>{{salaryhead.value}}</td> 
							            </tr>
										
										<tr v-for="salaryhead in salaryheads" :key="salaryhead.head" v-if="salaryhead.displayset == '7'">
							              <td><b>{{salaryhead.head}}</b></td> <td><b>{{salaryhead.value}}</b></td> 
							            </tr>
										
							       </tbody>
							      </table>
							   </div>
						 </div>

							
							<br>

			</form>
        </div>
			
</template>

  <script>
	  export default {
		  mounted() {
			 // console.log('Payslip started..');   
			 // console.log(this.componentdata);  
		  },
		  props: [ 'payslip'],
				 
   
		  data() {
			  
			  return {
			      employees : [],
			      salaryheads : [], 
				  taxinfo : [],
				  fiscalyears: [],
				  adhocfields: [],
				  adhocheadsnvalues: [],
				  slabs_and_values : [],
				  fdata: this.payslip,  
				  
				  success: '',
				  employee_id: '',
				  fiscal_year: '',
				  from_date: '',
				  to_date: '',
				  pay_slip_ref: '',
				  pay_slip_name: '',
				  month: '',
				  year: '',
				  adhoc_field: '',
				  adhoc_field_value: '',
				  

				  
				  
			  }
		  },
		  
		  methods:{
		  
			  
			  createTag: function()
			  {
			      //alert(this.from_date);
				  var fromdate=this.from_date;
				  var fromdatearray=fromdate.split("-");
				  var mnth=fromdatearray[1];
				  var month="";
				  var day="";
				  var year=fromdatearray[0];
				  if(mnth=="01")
				   month="January";

				  if(mnth=="02")
				   month="February";

				  if(mnth=="03")
				   month="March";

				  if(mnth=="04")
				   month="April";

				  if(mnth=="05")
				   month="May";

				  if(mnth=="06")
				   month="June";

				  if(mnth=="07")
				   month="July";

				  if(mnth=="08")
				   month="August";

				  if(mnth=="09")
				   month="September";

				  if(mnth=="10")
				   month="October";

				  if(mnth=="11")
				   month="November";
				   
				   if(mnth=="12")
				   month="December";
				   
				   if(mnth=="09" || mnth=="04" || mnth=="06" || mnth=="11")
				   day="30";
				   else
				   day="31";

                   this.to_date=day+" "+month+", "+year;
				   
				 var employee_name="Employee";  
				 var employeearray= this.employees;			   
					this.employees.forEach((value, index) => {
					if(this.employee_id==value.employee_id)
					employee_name=value.name;
					//console.log(value.name);
					//console.log(index);
					});
					
					this.pay_slip_name="Salary Slip of "+employee_name+" for "+month+", "+year;
					this.pay_slip_ref=this.employee_id+"-"+month+"-"+year;
					this.month=month;
					this.year=year;

				  
				  
			  },
			  
			  setSearch: function(pageflg)
			  {
			    if(this.from_date!='')
			    this.createTag();
				this.getSalaryinfo(); 
			  },
			  
			  showAdhoc: function(pageflg)
			  {
			    document.getElementById("adhoc_div").style.display="block";
				document.getElementById("adhoc_link_div").style.display="none";
				document.getElementById("status_div").style.display="none";
				
			  },
			  
			  hideAdhoc: function(pageflg)
			  {
			    document.getElementById("adhoc_div").style.display="none";
				document.getElementById("adhoc_link_div").style.display="block";
				document.getElementById("status_div").style.display="block";
				
			  },
			  
			  removeItem: function(pageflg)
			  {
			    //alert(pageflg);
				if(confirm("Are you Sure to Delete?"))
				{
					axios.get(this.$api_url+'/delete-adhoc/'+pageflg , {
								  params: {
									  page: 1,
									  
								  }
						  }).then(function(response){
							this.getSalaryinfo();   
	  
					  }.bind(this));
				  }
				
			  },
			  
			  saveAdhoc: function(pageflg)
			  {
			    //alert(this.adhoc_field) ;
				//alert(this.adhoc_field_value) ;
				
			  },
			  
			  getEmployees: function()
			  {
  
						  axios.get(this.$api_url+'/getemployees' , {
							  params: {
								  page: 1,
								  per_page: 1000000,
								  search_query: this.search,
								  search_query_by_id: '',
							  }
					  }).then(function(response){
					  this.employees = response.data.data;
  
  
				  }.bind(this));
			  },
			  
			  getFiscalyears: function()
			  {
  
						  axios.get(this.$api_url+'/getfiscalyears' , {
							  params: {
								  page: 1,
								  per_page: 10,
								  search_query: this.search,
								  search_query_by_id: '',
							  }
					  }).then(function(response){
					  this.fiscalyears = response.data;
  
  
				  }.bind(this));
			  },

  
			  
			   getSalaryinfo: function()
			  {
						  axios.get(this.$api_url+'/salary-slip/'+this.employee_id , {
							  params: {
								  fiscal_year: this.fiscal_year,
								  payslip_id: this.fdata.id,
								  search_query_by_id: '',
							  }
					  }).then(function(response){
					  //alert(response.data.salary);
					  this.salaryheads = response.data.salary;
					  this.slabs_and_values=response.data.slabsnvalues;
					  this.taxinfo=response.data.tax;
					  this.adhocfields=response.data.adhocfields;
					  this.adhocheadsnvalues=response.data.adhocheadsnvalues;
					  
					  
  
  
				  }.bind(this));
			  },
			  

			  
			  setSalaryinfo: function()
			  {
			  //
			  },
			  
			  
			  
  
  
			  formSubmit(e) {
  
				  e.preventDefault();
  
				  let currentObj = this;
  
   
  
				  const config = {
  
					  headers: { 'content-type': 'multipart/form-data' }
  
				  }
  
   
  
				  let formData = new FormData();
  
                   //formData.append('filename', this.image); 
				   formData.append('employee_id', this.employee_id);
				   formData.append('pay_slip_ref', this.pay_slip_ref);
				   formData.append('pay_slip_name', this.pay_slip_name);
				   formData.append('month', this.month);
				   formData.append('year', this.year);
				   formData.append('from_date', this.from_date);
				   formData.append('to_date', this.to_date);
				   formData.append('fiscal_year', this.fiscal_year); 
				   if(this.adhoc_field!='')
				   formData.append('adhoc_field', this.adhoc_field);
				   if(this.adhoc_field_value!='')
				   formData.append('adhoc_field_value', this.adhoc_field_value);

  
				  axios.post(this.$api_url+'/payslip-action-vue', formData, config)
  
				  .then(function (response) {
                      currentObj.getSalaryinfo();
					  currentObj.success = response.data.success;
					  currentObj.fdata.id = response.data.payslip_id;
					  currentObj.adhoc_field_value="";
					  currentObj.adhoc_field="";
					  currentObj.hideAdhoc();
					  
  
				  })
  
				  .catch(function (error) {
  
					  currentObj.output = error;
  
				  });
  
			  }
  
  
		  },
		  created: function(){
		  
		     this.getEmployees();
			 this.getFiscalyears();
			 
		  if(this.fdata.id!='')
		  {
		   this.fiscal_year=this.fdata.fiscal_year;
		   this.employee_id=this.fdata.employee_id;
		   this.from_date=this.fdata.from_date;
		   this.to_date=this.fdata.to_date;
		   this.pay_slip_ref=this.fdata.pay_slip_ref;
		   
		   this.setSearch();
		   this.pay_slip_name=this.fdata.pay_slip_name;
		  
		  }
			 //alert(this.fdata.employee_name);
			 
			 	
		  }
	  }
  </script>